import { render } from "./BtngroupRadio.vue?vue&type=template&id=245404ee&scoped=true"
import script from "./BtngroupRadio.vue?vue&type=script&lang=js"
export * from "./BtngroupRadio.vue?vue&type=script&lang=js"

import "./BtngroupRadio.vue?vue&type=style&index=0&id=245404ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245404ee"]])

export default __exports__